// import 'luxon';
import { TabulatorFull as Tabulator } from 'tabulator-tables';
import * as React from 'react';
// import 'react-tabulator/lib/styles.css'; // required styles
import 'tabulator-tables/dist/css/tabulator_site.css'; // theme
// import { ReactTabulator } from 'react-tabulator';
import { fetchSubmissions, fetchAllSubmissions, fetchSubmissionStatus, fetchSubmissionRows } from '../utility';
import { FaFileDownload } from 'react-icons/fa';
import { FaUpload } from 'react-icons/fa';
import { AiFillFolderAdd } from 'react-icons/ai';
import ReactDOMServer from 'react-dom/server';



const STATUS_TIMEOUT = 1000 * 3 * 1 // 1 second
const SUBMISSIONS_TABLE_ID = "submissions-table"
const PROGRESS_STATES = ["Submitted", "Queued", "Preprocessing", "Preprocessed", "Profiling", "Profiled"]
const PROGRESS_COLORS = ["#68bae9", "#68bae9", "#3fb449", "#68bae9", "#3fb449", "#68bae9"]
const BTN_TEXT = ["Start Preprocessing", "Cancel", "In Progress...", "View Profile", "In Progress...", "View Profile"]

let NESTED_DATA = [
    {
        project_name: "MTXX Samples", date_created: "2021-01-01", kits: [
            {
                kit_name: "MEGA Kit", each_submission: [
                    { panel: "MEGA A", status: "Submitted", progress: 20, biofluid: "Serum", date_created: new Date("2021-01-01") },
                    // {panel:"MEGA B", status:"Preprocessing", progress: 40, biofluid:"Serum", date_created: new Date("2021-01-02")},
                ]
            },
            {
                kit_name: "PRIME Kit", each_submission: [
                    { panel: "PRIME A", status: "Preprocessed", progress: 60, biofluid: "Serum", date_created: new Date("2021-01-02") },
                    // {panel:"PRIME B", status:"Profiling", progress: 80, biofluid:"Blood", date_created: new Date("2021-01-02")},
                ]
            },
        ]
    },
    {
        project_name: "TMIC Client#45 Samples", date_created: "2020-01-01", kits: [
            {
                kit_name: "PRIME Kit", each_submission: [
                    { panel: "FIA Positive", status: "Profiled", progress: 100, biofluid: "Fecal", date_created: new Date("2021-01-02") },
                    // {panel:"FIA Negative", status:"Profiled", progress: 100, biofluid:"Fecal", date_created: new Date("2021-01-02")},
                ]
            },
        ]
    },
]

const faFileDownloadHTML = ReactDOMServer.renderToString(
    <FaFileDownload />
)

const faUploadHTML = ReactDOMServer.renderToString(
    <FaUpload />
)

const aiFillFolderAddHTML = ReactDOMServer.renderToString(
    <AiFillFolderAdd />
)

export default Table = (props) => {


    const [submissionRows, setSubmissionRows] = React.useState([])  // direct representation of the rows in the db
    const [submissions, setSubmissions] = React.useState([])  // nested data structure for the front end submissions table
    const [table, setTable] = React.useState(null)
    // [
    //     Project_Name => [
    //         Assay => [
    //             { Submission 1 },
    //         ]
    //     ]
    // ]


    // STEP 1: initial hydration
    React.useEffect(() => {
        const fetchAndSetSubmissions = async () => {
            let allSubmissions = await fetchAllSubmissions()
            setSubmissions(allSubmissions)

            setTable(renderInitialTable(SUBMISSIONS_TABLE_ID, allSubmissions))

            let submissionRows = await fetchSubmissionRows()
            setSubmissionRows(submissionRows)
        }

        fetchAndSetSubmissions()

    }, []);


    // STEP 2: poll for status updates (only if submission object's status is "Preprocessing" or "Profiling")
    React.useEffect(() => {

        const pollAndUpdateSubmissionStatus = async () => {
            console.log("submission rows: ", submissionRows)
            for (const row of submissionRows) {
                if (["Profiling", "Preprocessing"].includes(row.status)) {
                    // let rowInterval = setInterval(async () => {
                    //     let status = await fetchSubmissionStatus(row.id)
                    //     console.log("status: ", status)
                    //     let submission = submissionRows.find((row) => row.id == status.submission_id)
                    //     console.log("submission: ", submission)
                    //     // STEP 3: update `submissions` state when status changes with newly fetched submissions which triggers the next useEffect
                    //     if (row.status != status.status) {
                    //         console.log("status should be updated", row.status, "=>", status.status)
                    //         // update submissions here
                    //         let allSubmissions = await fetchAllSubmissions()
                    //         setSubmissions(allSubmissions)
                    //         setTable(renderInitialTable(SUBMISSIONS_TABLE_ID, allSubmissions))
                    //         // update submissionRows here => this restarts this useEffect again (recursively)
                    //         setSubmissionRows(await fetchSubmissionRows())
                    //         clearInterval(rowInterval)
                    //     } 
                    // }, STATUS_TIMEOUT)
                }
            }
        }

        if (submissionRows.length > 0) pollAndUpdateSubmissionStatus()
    }, [submissionRows])  // only run this useEffect when submissionRows changes


    return (
        <div style={{ height: '100%' }}>
            <div className="table-light" id="submissions-table" style={{ height: '100%' }}></div>
        </div>
    )

}



let actionButtons = function (cell, formatterParams, onRendered) {
    let progress = cell.getRow().getData().progress
    // console.log("current status: ", progress)
    let stateButton = `
        <button class='btn btn-primary-lc w-50' onClick="window.location='${window.location.href + "submissions/" + cell.getRow().getData().id}'"
            ${[40, 80].includes(progress) ? "disabled=true" : ""}
            >${BTN_TEXT[progress]}</button>
    `
    let viewButton = ``
    let html = `
    <div class="btn-group w-100">
        ${stateButton}
        ${[40, 60, 80, 100].includes(progress) ? viewButton : ""}
        <button class='btn btn-danger'>Delete</button>
    </div>
    `
    return html;
};

let kitActionButtons = function (cell, formatterParams, onRendered) {
    let uploadFilesHref = window.location.href + "submissions/new?project_id=" + cell.getRow().getData().project_id + "&kit_registration_id=" + cell.getRow().getData().kit_registration_id
    let viewKitRegistrationHref = window.location.href + "kit_registrations/" + cell.getRow().getData().kit_registration_id
    let html = `
        <div class="btn-group w-100">
            <button class='btn btn-dark btn-outline-light w-50' onClick="window.location='${viewKitRegistrationHref}'">View Kit Registration</button>
            <button class='btn btn-dark btn-outline-light w-50' disabled='true'>${faFileDownloadHTML}Download Kit File Names</button>
            <button class='btn btn-dark btn-outline-light w-50' onClick="window.location='${uploadFilesHref}'">${faUploadHTML}Add Data Files</button>
        </div>
    `
    return html;
}


function updateTable(table, id, status, progress) {
    // options must include the key column: id, status, progress 
    table.updateData({
        id: id,
        status: status,
        progress: progress
    })
    return table
}


function renderInitialTable(divId, submissions) {

    //define table
    let tableEle = document.getElementById(divId);
    let table = new Tabulator(tableEle, {
        // height:"100%",
        // responsiveLayout:"collapse",
        renderVertical: "basic",
        layout: "fitColumns",
        columnDefaults: {
            // resizable:false,
        },
        data: submissions,
        columns: [
            {
                title: "Project ID",
                field: "project_id",
                visible: false,
            },
            {
                title: "Project Name",
                field: "project_name",
                responsive: true,
                headerFilter: "input",
                headerFilterPlaceholder: "Search by project name...",
                headerFilterFunc: "like",
                cssClass: "project-name-column",
                sorter: "string",
            },
            {
                title: "Date Created",
                field: "date_created",
                responsive: true,
                headerFilter: "input",
                headerFilterPlaceholder: "Search by date created...",
                headerFilterFunc: "like",
                cssClass: "project-name-column",
                hozAlign: "start",
                vertAlign: "middle",
                // width: 320,
                sorter: "date",
                sorterParams: {
                    format: "MM/DD/YYYY",
                },
                formatter: function (cell, formatterParams, onRendered) {
                    const dateValue = new Date(cell.getValue().split("T")[0])
                    const formattedDate = window.luxon.DateTime.fromJSDate(dateValue).toLocaleString({
                        month: '2-digit',
                        day: '2-digit',
                        year: 'numeric',
                    });
                    return formattedDate;
                },
                //TODO: sort by date, make sure you add the correct sorterParams date format as well
            }
        ],
        rowFormatter: function (row) {
            //create and style holder elements
            let holderEl = document.createElement("div");
            let tableEl = document.createElement("div");

            // holderEl.style.boxSizing = "border-box";
            holderEl.style.margin = "10px 30px 10px 30px";
            holderEl.style.paddingBottom = "10px";
            holderEl.style.borderBotom = "1px solid #333";
            // tableEl.style.border = "1px solid #333";
            tableEl.style.borderRadius = "5px";
            // tableEl.classList.add("table-light");

            holderEl.appendChild(tableEl);

            row.getElement().appendChild(holderEl);
            row.getElement().style.marginBottom = "1rem";

            let subTable = new Tabulator(tableEl, {
                layout: "fitColumns",
                data: row.getData().kits,
                columns: [
                    {
                        title: "Project ID",
                        field: "project_id",
                        visible: false,
                    },
                    {
                        title: "Kit ID",
                        field: "kit_registration_id",
                        visible: false,
                    },
                    {
                        title: "Kit Name",
                        field: "kit_name",
                        responsive: true,
                        cssClass: "kit-name-column",
                        // width: 260,
                    },
                    {
                        title: "Biofluid",
                        field: "biofluid",
                        responsive: true,
                        cssClass: "kit-name-column",
                        // width: 120,
                    },
                    {
                        title: "Assay",
                        field: "assay",
                        responsive: true,
                        cssClass: "kit-name-column",
                        // width: 120,
                    },
                    {
                        title: "Instrument",
                        field: "instrument",
                        responsive: true,
                        cssClass: "kit-name-column",
                        // width: 150,
                    },
                    {
                        title: "Actions",
                        formatter: kitActionButtons,
                        hozAlign: "center",
                        responsive: true,
                        cssClass: "kit-name-column",
                        width: 600,
                    }
                ],
                rowFormatter: function (innerRow) {
                    //create and style holder elements
                    let innerHolderEl = document.createElement("div");
                    let innerTableEl = document.createElement("div");

                    // innerHolderEl.style.boxSizing = "border-box";
                    // innerHolderEl.style.padding = "10px 10px 10px 10px";
                    // innerHolderEl.style.borderTop = "1px solid #333";
                    // innerHolderEl.style.borderBotom = "1px solid #333";
                    // // innerTableEl.style.border = "1px solid #333";
                    // innerTableEl.style.borderRadius = "5px";

                    innerHolderEl.appendChild(innerTableEl);

                    innerRow.getElement().appendChild(innerHolderEl);

                    // let kitName = row.getData().kit_name;
                    // if (kitName == "MEGA Kit") {
                    //     innerHolderEl.style.backgroundColor = "#3e72ed";
                    // } else if (kitName == "PRIME Kit") {
                    //     innerHolderEl.style.backgroundColor = "#ed3e4f";
                    // } else if (kitName == "FIA Kit") {
                    //     innerHolderEl.style.backgroundColor = "#34e361";
                    // }

                    let subSubTable = new Tabulator(innerTableEl, {
                        layout: "fitColumns",
                        data: innerRow.getData().each_submission,
                        columns: [
                            { field: "id", visible: false },
                            // {title:"Assay", field:"assay", hozAlign:"center", vertAlign:"middle", responsive: true, sorter: "string"},
                            { title: "Panel", field: "panel", hozAlign: "center", vertAlign: "middle", responsive: true, sorter: "string" },
                            // {title:"Biofluid", field:"biofluid", hozAlign:"center", vertAlign:"middle", responsive: true, sorter: "string"},
                            // {title:"Status", field:"status", hozAlign:"center", vertAlign:"middle", responsive: true, sorter: "string"},
                            {
                                title: "Date Created",
                                field: "date_created",
                                hozAlign: "center",
                                vertAlign: "middle",
                                responsive: true,
                                sorter: "date",
                                sorterParams: {
                                    format: "MM/DD/YYYY",
                                },
                                formatter: function (cell, formatterParams, onRendered) {
                                    const dateValue = new Date(cell.getValue().split("T")[0])
                                    const formattedDate = window.luxon.DateTime.fromJSDate(dateValue).toLocaleString({
                                        month: '2-digit',
                                        day: '2-digit',
                                        year: 'numeric',
                                    });
                                    return formattedDate;
                                },
                            },
                            {
                                title: "Progress", field: "progress", hozAlign: "left", formatter: "progress", responsive: true, vertAlign: "middle", sorter: "number", cssClass: "text-shadow",
                                formatterParams: {
                                    min: 0,
                                    max: PROGRESS_STATES.length - 1,
                                    legend: (value) => PROGRESS_STATES[parseInt(value)],
                                    legendAlign: "justify",
                                    color: (value) => PROGRESS_COLORS[parseInt(value)],
                                    //     switch (value) {
                                    //         case "20":
                                    //             return "#68bae9";
                                    //         case "40":
                                    //             return "#3fb449";
                                    //         case "60":
                                    //             return "#68bae9";
                                    //         case "80":
                                    //             return "#3fb449";
                                    //         case "100":
                                    //             return "#68bae9";
                                    //         default:
                                    //             return "#000000";
                                    //     }
                                    // },
                                }
                            },
                            { title: "Actions", formatter: actionButtons, hozAlign: "center", responsive: true },
                        ],
                    })
                }
            })
        },
    });





}